export const groupBy = (arr, key) =>
  arr.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x); // eslint-disable-line
    return rv;
  }, {});

export default { groupBy };



// WEBPACK FOOTER //
// ./app/utils/listHelpers.js